
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/dummy.js';
            vueApps['app/dummy.js'] = App0;
        

            import App1 from './redirects.js';
            vueApps['redirects.js'] = App1;
        

            import App2 from './app/unit.js';
            vueApps['app/unit.js'] = App2;
        

            import App3 from './app/search.js';
            vueApps['app/search.js'] = App3;
        

            import App4 from './app/navbar.js';
            vueApps['app/navbar.js'] = App4;
        

            import App5 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App5;
        

            import App6 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App6;
        

            import App7 from './app/LastViewedUnits.js';
            vueApps['app/LastViewedUnits.js'] = App7;
        

            import App8 from './app/Ubersicht-A-Z.js';
            vueApps['app/Ubersicht-A-Z.js'] = App8;
        

            import App9 from './app/ferienammeer.js';
            vueApps['app/ferienammeer.js'] = App9;
        

            import App10 from './app/grossligurien.js';
            vueApps['app/grossligurien.js'] = App10;
        

            import App11 from './app/gutngusting.js';
            vueApps['app/gutngusting.js'] = App11;
        

            import App12 from './app/aktuelleUnits.js';
            vueApps['app/aktuelleUnits.js'] = App12;
        

            import App13 from './app/ferienhundeerlaubt.js';
            vueApps['app/ferienhundeerlaubt.js'] = App13;
        

            import App14 from './app/hideaways.js';
            vueApps['app/hideaways.js'] = App14;
        

            import App15 from './app/ferienmitpool.js';
            vueApps['app/ferienmitpool.js'] = App15;
        

            import App16 from './app/nachhaltiger.js';
            vueApps['app/nachhaltiger.js'] = App16;
        

            import App17 from './app/ferienligurienmitpool.js';
            vueApps['app/ferienligurienmitpool.js'] = App17;
        

            import App18 from './app/ferienohneauto.js';
            vueApps['app/ferienohneauto.js'] = App18;
        

            import App19 from './app/urlablingurien.js';
            vueApps['app/urlablingurien.js'] = App19;
        

            import App20 from './app/urlaubmitkindern.js';
            vueApps['app/urlaubmitkindern.js'] = App20;
        

            import App21 from './app/urlaubzuzweit.js';
            vueApps['app/urlaubzuzweit.js'] = App21;
        

            import App22 from './app/ligurien.js';
            vueApps['app/ligurien.js'] = App22;
        

            import App23 from './app/ferienligurien.js';
            vueApps['app/ferienligurien.js'] = App23;
        

        
                import Comp24 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp24);
            

                import Comp25 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp25);
            

                import Comp26 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp26);
            

                import Comp27 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp27);
            

                import Comp28 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp28);
            

                import Comp29 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp29);
            

                import Comp30 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp30);
            

                import Comp31 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp31);
            

                import Comp32 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp32);
            

                import Comp33 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp33);
            

                import Comp34 from './comp/pricelist.vue';
                Vue.component('price-tab',Comp34);
            

                import Comp35 from './comp/pricetotal.vue';
                Vue.component('price-total',Comp35);
            

                import Comp36 from './comp/currencymod.vue';
                Vue.component('currency-mod',Comp36);
            

                import Comp37 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp37);
            

                import Comp38 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp38);
            

                import Comp39 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp39);
            

                import Comp40 from './comp/SearchFilterTokens-v2.vue';
                Vue.component('search-filter-tokens-v2',Comp40);
            

                import Comp41 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp41);
            

                import Comp42 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp42);
            

                import Comp43 from './pricehelp.vue';
                Vue.component('price-help',Comp43);
            

                import Comp44 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp44);
            

                import Comp45 from './comp/IncreaseNumber.vue';
                Vue.component('increase-number',Comp45);
            

                import Comp46 from './comp/PetsAllowedIconComp.vue';
                Vue.component('pets-allowed',Comp46);
            

                import Comp47 from './comp/Accordion.vue';
                Vue.component('voffice-accordion',Comp47);
            

                import Comp48 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp48);
            

                import Comp49 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp49);
            

                import Comp50 from './offershelp.vue';
                Vue.component('offer-help',Comp50);
            

                import Comp51 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp51);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    